import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { MsisdnListInterface } from '../../models/msisdn-list.interface';

@Component({
  selector: 'app-modal-lines-list',
  templateUrl: './modal-lines-list.component.html',
  styleUrls: ['./modal-lines-list.component.css'],
  standalone: false
})
export class ModalLinesListComponent implements OnInit {

  @Input()
  msisdnList: Array<MsisdnListInterface>;

  msisdnListCopy: Array<MsisdnListInterface>;

  @Input()
  visibility: boolean = true;

  @Output()
  closedListLines = new EventEmitter<{ status: number, msisdn: string|null }>();

  selectedMsisdn: string|null;
  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.msisdnListCopy = this.msisdnList;
    this.selectedMsisdn = null;
  }

  closeLinesList(e) {
    this.visibility = false;
    this.closedListLines.emit({ status: 1, msisdn: this.selectedMsisdn});
  }

  filter($event) {
    if ($event.target.value === '') {
      this.msisdnListCopy = this.msisdnList;
    } else {
      this.msisdnListCopy = [];
      for (const msisdn of this.msisdnList) {
        if (msisdn.phoneNumber.includes($event.target.value) || msisdn.titular.toLowerCase().includes($event.target.value.toLowerCase())) {
          this.msisdnListCopy.push(msisdn);
        }
      }
    }
  }

  setSelectedLine(phoneNumber?: string) {
    this.msisdnListCopy = this.msisdnList;
    this.selectedMsisdn = phoneNumber;
    this.visibility = false;
    this.closedListLines.emit({ status: 1, msisdn: this.selectedMsisdn});
  }
}
